export const intermediateContent = [
  {
    id: 'intermediate-3',
    icon: '👥',
    title: 'Sie sind nicht allein!',
    text: 'Über 80% der Frauen in Ihrem Alter teilen ähnliche Hautbedürfnisse. Die natürliche Hautalterung beginnt bereits ab 25 Jahren, aber mit der richtigen Pflege können wir diesen Prozess verlangsamen und Ihre Hautgesundheit optimal unterstützen.'
  },
  {
    id: 'intermediate-6',
    icon: '🔬',
    title: 'Wissenschaftliche Erkenntnisse',
    text: 'DHT (Dihydrotestosteron) spielt eine wichtige Rolle bei der Hautalterung. Es kann die Kollagenproduktion reduzieren und die Hautstruktur beeinflussen. Unsere Formel wurde speziell entwickelt, um diesen Prozess zu unterstützen und Ihre Haut von innen zu stärken.'
  },
  {
    id: 'intermediate-10',
    icon: '✨',
    title: 'Einzigartige Formel',
    text: 'Derma Renew Complex kombiniert wissenschaftlich erprobte Inhaltsstoffe in einer optimalen Dosierung. Im Gegensatz zu herkömmlichen Produkten wirkt unsere Formel von innen heraus und unterstützt die natürlichen Regenerationsprozesse Ihrer Haut.'
  },
  {
    id: 'intermediate-14',
    icon: '🌟',
    title: 'Erfolgsgeschichten',
    text: 'Tausende zufriedener Kunden haben bereits mit Derma Renew Complex ihre Hautgesundheit verbessert. 94% unserer Kunden berichten von sichtbaren Verbesserungen innerhalb der ersten 4 Wochen.'
  },
  {
    id: 'intermediate-18',
    icon: '📊',
    title: 'Ihre Analyse wird erstellt',
    text: 'Basierend auf Ihren Antworten erstellen wir jetzt Ihre personalisierte Hautanalyse. Wir berücksichtigen dabei Ihre individuellen Bedürfnisse, Ihren Lebensstil und Ihre Hautziele, um Ihnen die optimale Lösung zu bieten.'
  }
]; 